var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 78,
    viewBox: "0 0 8 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64644 77.3536C3.84171 77.5488 4.15829 77.5488 4.35355 77.3536L7.53553 74.1716C7.73079 73.9763 7.73079 73.6597 7.53553 73.4645C7.34027 73.2692 7.02369 73.2692 6.82842 73.4645L4 76.2929L1.17157 73.4645C0.976308 73.2692 0.659725 73.2692 0.464463 73.4645C0.269201 73.6597 0.269201 73.9763 0.464463 74.1716L3.64644 77.3536ZM3.5 -2.18557e-08L3.5 77L4.5 77L4.5 2.18557e-08L3.5 -2.18557e-08Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineArrow);
export default __webpack_public_path__ + "static/media/lineArrow.7faca28a147ed9b8c7a1b1eb94055b47.svg";
export { ForwardRef as ReactComponent };